export default __webpack_public_path__ + "static/media/ultratech-logo.650efdf3.png";